module.exports = __webpack_public_path__ + "assets/202509252035/img/ZX.77adb7b6.jpg";